import React from 'react';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import { connect } from 'react-redux';
import { NewArrivalContainerStyled } from './styled';
import { userService } from 'apiService';
// import { iconImages } from 'assets';
import { setReduxUserAuth } from 'actions';
import { BoxImage } from 'components';
import { ROUTE_PATH ,renderImage} from 'helpers';
import { Helmet } from "react-helmet";

class NewArrivalContainer extends React.Component {
  state = {};

  componentDidMount() {
    this.fetchData();

    // Tracking user pageview
    ReactGA.set({ page: this.props.location.pathname });
    ReactGA.pageview(this.props.location.pathname);
    ReactPixel.pageView();
  }

  fetchData = async () => {
    let res = await userService.GET_NEW_ARRIVAL_ALL_LIST();
    if (res && res.success) {
      this.setState({
        data: res.data,
      });
    }
  };

  handleClickCreatorDetail = (id) => {
    this.props.history.push(`${ROUTE_PATH.CREATOR}/${id}`);
  };
  
  render() {
    const { data } = this.state;
    return (
      <NewArrivalContainerStyled>
        {data && (
          <Helmet>
            <title>New Arrival</title>
            <meta
              name="og:image"
              content={
                data.posters && data.posters.length > 0
                  ? data.posters[0].uri
                  : null
              }
            />
            <meta name="og:title" content={data.displayname} />
          </Helmet>
        )}
        <div className="text_title">New Arrival</div>
        <div className="container">
          {data &&
            data.map((e, i) => (
              <div
                key={i}
                className="item_wrap"
                onClick={() => this.handleClickCreatorDetail(e.id)}
              >
                <BoxImage
                  theme_standard
                  classManual="dynamic"
                  name={e.displayname}
                  detail={e.description}
                  src={e && renderImage(e)}
                  // src={
                  //   (e.posters && e.posters.length > 0 && e.posters[0].uri) ||
                  //   iconImages['Loading.png']
                  // }
                />
              </div>
            ))}
        </div>
      </NewArrivalContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authRedux: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  setReduxUserAuth: (data) => dispatch(setReduxUserAuth(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewArrivalContainer);
